
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/form-label",
      function () {
        return require("private-next-pages/material-ui/api/form-label.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/form-label"])
      });
    }
  